import { Enum_FileSize, SUPPORTED_FORMATS_FILE } from "../../enums/enums";
import { IFileValidation } from "./interfaces/IFileValidation";
import { PDFDocument } from "pdf-lib";

export const fileHandleSelect = (file: File) => {
  let fileValidation: IFileValidation = {
    noValid: false,
    noValidSize: false,
    noValidName: false,
    ok: false,
  };

  if (file) {
    // Verificar el tamaño del archivo
    if (file.size > Enum_FileSize.maxAllowedSize) {
      fileValidation.noValidSize = true;
      fileValidation.ok = true;
    }

    // Verificar el tipo de archivo
    let fileType = file.type;
    if (!SUPPORTED_FORMATS_FILE.TYPE.includes(fileType)) {
      fileValidation.noValid = true;
      fileValidation.ok = true;
    }

    // Verificar si el nombre del archivo contiene caracteres especiales
    const fileName = file.name.trim(); // Eliminar espacios al inicio y al final

    const invalidChars = /[^\w.\- ()]/; // Ahora permite letras, números, puntos, guiones y paréntesis
    if (invalidChars.test(fileName)) {
      fileValidation.noValidName = true;
      fileValidation.ok = true;
    }

    // // Verificar si contiene espacios en blanco al inicio o al final
    // if (file.name !== fileName) {
    //   fileValidation.NoValidName = true; // Si el nombre original cambia tras el trim, tenía espacios al inicio o al final
    //fileValidation.ok=true;
    // }

    //const invalidBlankSpaces = /\s/; // Detecta cualquier espacio en blanco en el nombre del archivo

    // if (invalidBlankSpaces.test(fileName)) {
    //   fileValidation.NoValidName = true;
    // fileValidation.ok=true;
    // }
  }

  return fileValidation;
};

export async function isPasswordProtected(file: any) {
  try {
    await PDFDocument.load(await file.arrayBuffer());
    return true; //  no tiene contraseña
  } catch (error) {
    return false; // Con traseña
  }
}
